<template>
          <v-card-text>
            <v-card>
              <v-container fluid v-if="!is_reset">
                <v-row no-gutters>
                  <v-col cols="12" class="text-center">
                    <v-icon size="100" color="black">mdi-lock</v-icon>
                  </v-col>
                </v-row>
                <v-row no-gutters class="d-flex justify-center align-center">
                  <v-col cols="12" sm="12" class="text-center">
                    <h2 class="text-center font-weight-bold">
                      FORGET PASSWORD
                    </h2>
                    <span class="text-center">
                      Enter your account username to start the password recovery
                      process.
                    </span>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col class="pa-2">
                    <v-text-field v-model="form.username" outlined dense hide-details @keypress.enter="findUsername()">
                      <template #prepend-inner>
                        <v-icon>mdi-account-outline</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12" class="d-flex justify-center align-center pa-0">
                    <v-btn color="primary" @click="findUsername()" small>
                      <v-progress-circular
                        v-if="findAccountLoad"
                        size="20"
                        indeterminate
                        color="white"
                      >
                      </v-progress-circular>
                      <span v-else>Find Account</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
              <v-container fluid v-if="is_reset && !is_sent">
                <v-row>
                  <v-col cols="12" class="d-flex justify-center align-center">
                    <v-icon size="150">mdi-account-circle</v-icon>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12" class="d-flex justify-center align-center">
                    <span>Hello! {{ account_info?.name }}</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="d-flex">
                    <h6 class="text-center">
                      Choose where we should send your password reset code.
                    </h6>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12" class="pa-0">
                    <v-radio-group label="Send code via?" hide-details v-model="active">
                      <v-radio
                        :value="{
                          type: 'email',
                          value: account_info.email,
                        }"
                        name="email"
                        class="mt-3 mb-3"
                        :disabled="
                          maskEmail(account_info.email, 'No email available') ==
                          'No email available'
                            ? true
                            : false
                        "
                        :label="
                          maskEmail(account_info.email, 'No email available')
                        "
                      >
                      </v-radio>

                      <v-radio
                        :value="{
                          type: 'mobile',
                          value: account_info.mobile_no,
                        }"
                        name="sms"
                        class="mt-3 mb-3"
                        :disabled="
                          maskEmail(
                            account_info.mobile_no,
                            'No mobile number available'
                          ) == 'No mobile number available'
                            ? true
                            : false
                        "
                        :label="
                          maskEmail(
                            account_info.mobile_no,
                            'No mobile number available'
                          )
                        "
                      >
                      </v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12" class="d-flex justify-center align-center">
                    <v-btn :disabled="!active || is_send" color="gray" @click="sendCode()">
                       <v-progress-circular
                        v-if="is_send"
                        size="20"
                        indeterminate
                        color="white"
                      >
                      </v-progress-circular>
                      <span v-else>Send</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>

               <v-container fluid v-if="is_sent && !is_change_password">
                <v-row>
                  <v-col cols="12" class="d-flex justify-center align-center">
                    <h2 class="text-center font-weight-bold">OTP Verification</h2>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12" class="d-flex justify-center align-center">
                    <span class="text-center">A One-Time Password has been sent to <b>{{ active?.value }}</b></span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="justify-center align-center">
                      <v-otp-input
                        v-model="otp"
                        length="6"
                      ></v-otp-input>
                      <div class="text-center pb-2" v-if="is_error_otp" style="color:#f76769;">Please enter the valid code.</div>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col class="d-flex justify-center align-center pb-2">
                    <span class="text-center">Code expires in: <b>{{ otpExpireTime }}</b></span>
                  </v-col>
                  <v-col cols="12" class="d-flex justify-center align-center">
                    <v-btn small :disabled="!this.active" color="gray" @click="verifyOTP()">Verify</v-btn>
                  </v-col>
                </v-row>
              </v-container>

              <v-container fluid v-if="is_change_password">
                <v-row no-gutters>
                  <v-col cols="12" class="d-flex justify-center align-center pa-0">
                    <h2 class="text-center font-weight-bold">Change Password</h2>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12" class="d-flex justify-center align-center pa-0">
                    <span class="text-center">Your identity has been verified set your new password</span>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col class="pa-2">
                    <v-text-field label="New Password" :type="this.pw_type" v-model="form.new_password" hide-details outlined dense>
                      <template #prepend-inner>
                        <v-icon @click="showPassword()">{{pw_icon}}</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col class="pa-2">
                    <v-text-field label="Confirm Password" type="password" v-model="form.confirm_new_password" hide-details outlined dense>
                      <template #prepend-inner>
                        <v-icon>mdi-key</v-icon>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12" class="d-flex justify-center align-center">
                    <v-btn :disabled="change_pass_load" color="primary" small @click="changePassword()">
                      <v-progress-circular
                        v-if="change_pass_load"
                        size="20"
                        indeterminate
                        color="white"
                      >
                      </v-progress-circular>
                      <span v-else>Change Password</span>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
              
              <v-container fluid>
                <v-row no-gutters class="pa-0">
                  <v-col
                    cols="12"
                    class="d-flex justify-center align-center border-top"
                  >
                    <h5 v-if="!is_sent || is_change_password" class="fgt-pw pt-2" @click="forgotPassword()">
                       <v-icon small>mdi-arrow-left</v-icon> {{ USER && USER.id ? 'Go back' : 'Login' }}
                    </h5>
                    <h6 v-if="!is_send && is_sent && !is_change_password" class="fgt-pw pt-2" @click="sendCode()">Didn't receive code? <span style="text-decoration: underline; color: #5294fd;">Request Again</span></h6>
                    <span v-if="is_send && is_sent">Sending Please wait...</span>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-card-text>
 
</template>

<script>
import { mapGetters } from 'vuex';
import swal from "sweetalert2";
export default {
  data: () => ({
    form: {
      username: null,
      password: null,
      new_password:'',
      confirm_new_password:''
    },
    account_info: {},
    loading: false,
    is_reset: false,
    findAccountLoad: false,
    active:'',
    otp:'',
    is_sent:false,
    is_send:false,
    is_change_password:false,
    is_error_otp:false,
    show_password:false,
    pw_icon:'mdi-eye-off',
    pw_type:'password',
    change_pass_load:false,
    expiryTime:'',
    otpExpireTime:'',
    _otpInterval: null,
  }),
  computed:{
    ...mapGetters(['GET_RESET_PASSWORD','USER']),
  },
  beforeDestroy() {
    if (this._otpInterval) {
      clearInterval(this._otpInterval);
      this._otpInterval = null;
    }
  },
  methods: {
    updateCountdown() {
      const now = new Date();
      const remainingMs = this.expiryTime - now;
      if (remainingMs <= 0) {
        clearInterval(this._otpInterval);
        this._otpInterval = null;
        this.otpExpireTime = '00:00';
        return;
      }

      const remainingSec = Math.floor(remainingMs / 1000);
      const minutes = Math.floor(remainingSec / 60);
      const seconds = remainingSec % 60;
      this.otpExpireTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    },
    login() {
      if (this.form.username && this.form.password) {
        this.loading = true;

        this.$store
          .dispatch("login", this.form)
          .then((response) => {
            this.loading = false;
            this.$router.push("/home");
          })
          .catch((error) => {
            console.log(error);
            swal.fire({
              title: "Error!",
              text: error.response.data.error,
              icon: "error",
            });

            this.form.password = null;
            this.loading = false;
          });
      }
    },
    forgotPassword() {
 
      this.$emit('forgotPassword',false)
    //   if (this.GET_RESET_PASSWORD) {
        this.is_reset = false;
        this.findAccountLoad =  false,
        this.active = '',
        this.otp = '',
        this.is_sent = false,
        this.is_send = false,
        this.is_change_password = false,
        this.is_error_otp = false,
        this.show_password = false,
        this.pw_icon = 'mdi-eye-off',
        this.pw_type = 'password',
        this.change_pass_load = false
        this.$store.commit('FORGOT_PASSWORD_TOKEN','');
    //   }
    },
    async findUsername() {
      this.findAccountLoad = true;
      if (!this.form.username) {
        swal.fire({
          toast: true,
          text: "please enter your username to start password recovery.",
          icon: "warning",
          showConfirmButton: false,
          timer: 3000,
        });

        this.findAccountLoad = false;

        return true;
      }
      Object.assign(this.form, { is_reset: true });
      this.$store.dispatch("login", this.form).then((response) => {
        if (response.data?.name) {
          this.is_reset = true;
          this.account_info = response.data;
          if(response.token){
            this.$store.commit('FORGOT_PASSWORD_TOKEN',response.token);
          }
          if(this.account_info.email){
            this.active = {type:'email',value:this.account_info.email}
          }
          
        } else {
          swal.fire({
            toast: true,
            text: "username not found!",
            icon: "error",
            showConfirmButton: false,
            timer: 3000,
          });
        }

        this.findAccountLoad = false;
      }).catch(()=>{
        this.findAccountLoad = false;
      });
    },
    maskEmail(value, falseValue) {
      if (value) {
        const parts = value?.split("@");
        const username = parts ? parts[0] : value;
        const domain = parts ? parts[1] : value;
        const maskedUsername =
          parts.length > 1
            ? username.substr(0, 2) + "*".repeat(username.length - 2)
            : username.substr(0, 6) + "*".repeat(username.length - 6);
        const maskedEmail =
          parts.length > 1 ? maskedUsername + "@" + domain : maskedUsername;
        return maskedEmail;
      } else {
        return falseValue;
      }
    },
    sendCode(){
      this.is_send = true
      if(this.active.type != 'email'){
        swal.fire({
          toast:true,
          title:'Sorry this method cannot be use right now, Please try again later',
          timer:3000,
          showConfirmButton:false,
        })
        this.is_send = false
        return false;
      }
      this.$store.dispatch('sendCode',this.active).then((response)=>{
        if(response.status == 200){
            this.is_sent = true
            this.is_send = false
            if (this._otpInterval) {
              clearInterval(this._otpInterval);
            }
            const time = new Date();
            this.expiryTime = new Date(time.getTime() + 5 * 60 * 1000);
            this.updateCountdown()
            this._otpInterval = setInterval(this.updateCountdown, 1000)
        }
      }).catch((e)=>{
        this.is_send = false
      });
    },
    verifyOTP(){
      this.is_error_otp = false
      this.$store.dispatch('verifyOTP',{otp:this.otp}).then((response)=>{
        if(response.data?.message){
           this.is_change_password = response.data?.code;
           if(!response.data?.code){
              this.is_error_otp = true
              setTimeout((e)=>{
                this.is_error_otp = false
              },5000)
           }else{
            this.is_error_otp = false
           }
        }
      }).catch((e)=>{
        this.is_error_otp = false
      });
    },
    showPassword(){
      this.show_password = !this.show_password;
      if(this.show_password){
          this.pw_icon = 'mdi-eye-outline'
          this.pw_type = 'text'
      }else{
        this.pw_icon = 'mdi-eye-off'
        this.pw_type = 'password'
      }
    },
    changePassword(){
        this.change_pass_load = true;
        if(this.form.new_password.length < 8){
          swal.fire({
                toast:true,
                title:'Password is too short. Please use at least 8 characters.',
                icon:'warning'
            })
            this.change_pass_load = false;
            return false;
        }
        if(this.form.new_password == this.form.confirm_new_password && this.form.new_password != '' && this.form.confirm_new_password != ''){
          let payload = {
            new_password:this.form.confirm_new_password,
          }
          this.$store.dispatch('changePassword',payload).then((response)=>{
            if(response.status == 200){
              this.change_pass_load = false
              delete this.form.is_reset;
              if(!this.USER.id){
                    swal.fire({
                        icon:'question',
                        title:'you want to sign in now?',
                        showCancelButton:true,
                        showConfirmButton:true,
                        cancelButtonText:'Not now',
                        confirmButtonText:'Yes',
                        reverseButtons:true,
                        allowOutsideClick:false,
                    }).then((response)=>{
                        if(response.isConfirmed){
                        this.form.password = this.form.confirm_new_password
                        this.login();
                        this.$store.commit('FORGOT_PASSWORD_TOKEN','');
                        Object.assign(this.$data, this.$options.data.call(this))
                        }else{
                        this.$store.commit('FORGOT_PASSWORD_TOKEN','');
                        Object.assign(this.$data, this.$options.data.call(this))
                        }
                    })
              }else{
                Object.assign(this.$data, this.$options.data.call(this))
                this.forgotPassword();
              }
              
            }else{
              swal.fire({
                toast:true,
                title:'Error Please contact your administrator immediately',
                icon:'error'
              })
            }
          }).catch((error)=>{
            swal.fire({
                toast:true,
                title:'Error Please contact your administrator immediately',
                icon:'error'
            })
            this.change_pass_load = false;
          })
        }else{
          swal.fire({
            toast:true,
            title:'Please enter a valid password',
            icon:'warning'
          })
          this.change_pass_load = false
        }
    }
  },
  watch:{
    USER:{
        handler(val){
            if(val && val.username){
            this.is_reset = true;
            this.account_info = val;
                if(this.account_info.email){
                    this.active = {type:'email',value:this.account_info.email}
                }
            }
        },
        deep:true,
        immediate:true
    },
  }
  
};
</script>
<style scoped>
.centered-input >>> input {
  text-align: center;
}
.fgt-pw:hover {
  color: #666666;
  cursor: pointer;
}
</style>